import configGrantsAirportTransferForTier from './configGrantsAirportTransferForTier'

interface CanUseAirportTransferBenefitInput {
  userBenefits?: Array<App.LoyaltyBenefit>
  loyaltyConfig?: App.LoyaltyConfig
  accountTier?: App.LoyaltyTier
  isTasteOfGoldEligible?: boolean
}

export function hasAvailableLoyaltyBenefit(
  userBenefits: Array<App.LoyaltyBenefit> | undefined,
  benefitCode: App.LoyaltyBenefitType,
): boolean {
  const benefit = userBenefits?.find(benefit => benefit.code === benefitCode)

  return !!benefit && (benefit.unlimited || !!benefit.remaining)
}

export function hasIssuedLoyaltyBenefit(
  order: App.Order | undefined,
  benefitCode: App.LoyaltyBenefitType,
): boolean {
  return !!order?.loyaltyDetails.benefitsRedeemed.some(
    benefit => benefit.code === benefitCode && benefit.status === 'ISSUED',
  )
}

export function canUseAirportTransferBenefit(input: CanUseAirportTransferBenefitInput): boolean {
  const {
    userBenefits,
    loyaltyConfig,
    accountTier,
    isTasteOfGoldEligible,
  } = input

  return configGrantsAirportTransferForTier(loyaltyConfig, accountTier) &&
    (hasAvailableLoyaltyBenefit(userBenefits, 'airport_transfer') || !!isTasteOfGoldEligible)
}
